module.exports = __webpack_public_path__ + "img/fawry.206fbfdc.png";